import React from 'react'
import CourseAsideHero from '../../../reusable/CourseAsideHero'
import CoursesAside from '../../../reusable/Aside-courses'
import CourseCard from '../../../reusable/Course-card'
import { BANKING_BOTTOM_CONTENT, DATA_COURSE_PAGE_2, DATA_DETAILS_PAGE_2, DATA_HERO_PAGE_2 } from '../../../utils/constants'
import { DATA_ACCORDIAN_2 } from '../../../utils/courseConifg'
import Accordian from '../../../reusable/Accordian'
import PageDesc from '../../../reusable/PageDesc'

const DataSciencePage_2 = () => {
  return (
    <div className='outlet-render'>
            <CourseAsideHero {...DATA_HERO_PAGE_2}/>
      <CoursesAside {...DATA_COURSE_PAGE_2}/>
      <CourseCard {...DATA_DETAILS_PAGE_2}/>
      <Accordian {...DATA_ACCORDIAN_2}/>
      <PageDesc {...BANKING_BOTTOM_CONTENT}/>
    </div>
  )
}

export default DataSciencePage_2